import CorporatesView from './CorporatesView';

const views = {
  CorporatesView,
};
export default views;
